import { ReactElement } from "react";
//#region types
import { BaseFormExpandableStepProps } from "models/propTypes/wintFormPropsTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { ExpandableSection, ExpandableSectionSummary } from "components/common/wintForms";
import { PeriodisationField } from "components/common";
//#endregion
import { TranslationKeys } from "translations";
import { AccrualHelper, LocalizationHelperInstance, PeriodisationRowsHelper } from "utils/helpers";

interface PeriodisationStepProps extends BaseFormExpandableStepProps<IncomingInvoiceFormTypes.Todo> {
  invoice: WintSuperkollAPIModel.IncomingInvoice;
  netAmount: number;
  fileViewer?: ReactElement;
}

const PeriodisationStep: React.FC<PeriodisationStepProps> = ({
  connect,
  values,
  expandableStepProps,
  invoice,
  netAmount,
  fileViewer,
}) => {
  const periodisationFieldProps = connect("periodisation");
  const invoiceMonth = PeriodisationRowsHelper.invoiceMonth(invoice.invoiceDate);

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accrual)}
          subText={AccrualHelper.getRowsAccrualSummary(values.periodisation, invoiceMonth)}
        />
      }
      hasErrors={periodisationFieldProps.hasErrors}
      {...expandableStepProps}
    >
      <PeriodisationField
        {...periodisationFieldProps}
        netAmount={netAmount}
        currency={invoice.currency}
        splitSupported={PeriodisationRowsHelper.isSplitSupported(invoice)}
        fileViewer={fileViewer}
        invoiceMonth={invoiceMonth}
        isCredit={invoice.isCredit}
        compactSummary
      />
    </ExpandableSection>
  );
};

export default PeriodisationStep;
